export enum CreateMeetingEventType {
  SCHEDULE = 'Schedule',
  START_MEETING = 'Start Meeting',
}

export enum GTMMeetingInteractionAction {
  START_NOW = 'Start Now',
  EDIT = 'Edit',
  CHANGED = 'Changed',
  REMOVED = 'Removed',
  COPY_DETAILS = 'Copy Details',
  SEND_INVITE = 'Send Invite',
  SAVED_CHANGES = 'Saved Settings',
  SCHEDULE = 'Schedule',
  DELETE = 'Delete',
  ADDED = 'Added',
}

export interface CovideoGTMMeetingAttributes {
  meetingId?: string;
  meetingTitle?: string;
  invitedParticipants?: number;
  meetingUrl?: string;
  meetingDate?: string;
  meetingTime?: string;
  meetingHost?: number;
  crmParticipants?: string[];
}

export interface GTMMeetingAttributes {
  /**
   * The unique identifier for the meeting.
   * @example "oeQxSHXAzy"
   */
  meeting_id?: string;
  /**
   * The title of the meeting.
   * @example "test no invite"
   */
  meeting_title?: string;
  /**
   * The URL of the meeting.
   * @example "https://video.connectcdk.com/live/oeQxSHXAzy"
   */
  meeting_url?: string;
  /**
   * The date and time when the meeting is scheduled to occur.
   * @example  "09/30/2025"
   */
  meeting_date?: string;
  /**
      * The time when the meeting is scheduled to occur. 
      @example "10:45 AM"
     */
  meeting_time?: string;
  /**
   * The unique identifier of the host user who created the meeting.
   * @example  "134564 (CRM Agent ID)"
   */
  meeting_host?: number;
  /**
   * The list of participants invited to the meeting.
   * @example ['12453','3454'']
   */
  crm_participants?: string[];

  /**
   * The number of participants invited to the meeting.
   * @example 2
   */
  invited_participants?: number;
}
